import { render } from "./IntermiadiateBlock.vue?vue&type=template&id=79e4a738&ts=true"
import script from "./IntermiadiateBlock.vue?vue&type=script&lang=ts"
export * from "./IntermiadiateBlock.vue?vue&type=script&lang=ts"

import "./IntermiadiateBlock.vue?vue&type=style&index=0&id=79e4a738&lang=scss"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__